import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import WarningIcon from '@mui/icons-material/WarningRounded';

export default function Confirmation(props) {
    const [text, setText] = useState(props.text)
        
    return (
        <Dialog open={props.text ? true : false} onClose={() => {props.onClose()}} fullWidth maxWidth="xs" >
            <DialogTitle id="alert-dialog-title">
                {props.title ?? 'Warning'}
            </DialogTitle>
            <DialogContent>
                <Stack direction="row" spacing={2}>
                    <WarningIcon color="warning" sx={{ fontSize:40 }}/>
                    <DialogContentText>
                        {props.text}
                    </DialogContentText>
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => {props.onClose()}} autoFocus>OK</Button>
            </DialogActions>
        </Dialog>
    )
}